import { useLocale } from "@/hooks/useLocale";
import { Banner } from "@/ui/Banner";
import { DynamicText } from "@/ui/DynamicText";
import { Button, Col, Row } from "react-bootstrap";
import { DynamicHtml } from "@/ui/DynamicHtml";
import ExternalLink from "@/assets/ExternalLink.svg";
import { useLink } from "@/hooks/useLink";
import Image from "@/ui/Image";

export const DiversityPageBannerSection = ({ className, pathPrefix }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`${pathPrefix}.title.${locale}`} tag="h1" />}
      image={{ path: `${pathPrefix}.image`, src: "/assets/banners/default.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`${pathPrefix}.text.${locale}`} className="me-4" />
        </Col>
        <Col xs={12} md={6}>
          <Image
            img={{ path: `${pathPrefix}.logo`, src: "/assets/diversity/dei.png" }}
            size="626x396"
            className="w-100"
            alt=""
          />
        </Col>
        <Col xs={12}>
          <Button href={link("contact")} className="mt-3 mt-md-0" variant="secondary">
            <DynamicText path={`${pathPrefix}.button.${locale}`} />
            <ExternalLink className="ms-3" />
          </Button>
        </Col>
      </Row>
    </Banner>
  );
};

DiversityPageBannerSection.defaultProps = {
  pathPrefix: `page.diversity.banner`,
};
